export default "__VITE_ASSET__CXFZeWQk__"